import React, { Component } from "react";
import Wrp from '../../../../hoc/Wrp/Wrp';
import Icons from "../../../../Components/Icons/Icons";
import DocumentListing from './DocumentListing';
import GridListing from './GridListing';
import {callDELETE, callGET, callPOST} from '../../../../Utils/ApiUtil';
import {formatBytes} from '../../../../Utils/CommonFunctions';

class MainContent extends Component {
	constructor(props) {
        super(props);
    }

    state={
    	tableRecords:{
        tableHead:[
          {
          	name:"",
          	type:"Actions",
          	isShow:true,
          	attributes:{style:{width: "75px"}}
          },          
          {
            name:"Name",
            type:"Setting",
            href:"",
            clickHandler:"",
            isShow:true,
            attributes:{
            }
          },
          {
            name:"Owner",
            type:"Text",
            href:"",
            isShow:true,
            clickHandler:"",
            attributes:{
            }
          },
          {
            name:"Type",
            type:"Text",
            href:"",
            isShow:true,
            clickHandler:"",
            attributes:{
            }
          },
          {
            name:"Size",
            type:"Text",
            href:"",
            isShow:true,
            clickHandler:"",
            attributes:{
            }
          },          
        ],
        tableData:[], 
        pagination:{
          page:0,
          orderBy:'',
          perPage:10,
          direction:'ASC',
          totalRecords:0,
          search:''
        }
      },
    }

    componentDidMount = () => {
    	//console.log('componentDidMount',this.props.ListingModules) 
    	// Don't call listing data on mount - wait for parent to auto-select directory first
    	// callListingData will be triggered by componentDidUpdate when props change
    }

    componentDidUpdate = (prevProps) => {
    	if(prevProps.ListingModules!==this.props.ListingModules || prevProps.ListingDirectoryID!==this.props.ListingDirectoryID || prevProps.ListingType!==this.props.ListingType || prevProps.ListingModulesFlag!==this.props.ListingModulesFlag){
    		// console.log('componentWillUpdate', this.props.ListingType,prevProps.ListingType)
    		// Reset pagination to default when directory/module changes
    		const defaultPagination = {
    			page:0,
    			orderBy:'',
    			perPage:10,
    			direction:'ASC',
    			totalRecords:0,
    			search:''
    		};
    		this.setState({
    			tableRecords:{
    				...this.state.tableRecords,
    				pagination:defaultPagination
    			}
    		}, () => {
    			this.callListingData(defaultPagination);
    		});
    	}    	
    }

    callListingData = async (pagination=this.state.tableRecords.pagination) => {		
	  const {page,orderBy,perPage,direction,totalRecords,search}=pagination;
	  // Update state with new pagination before making API call
	  this.setState({
		tableRecords:{
		  ...this.state.tableRecords,
		  pagination:pagination
		}
	  });
      const { ListingModules, ListingDirectoryID, activeHeaderTab } = this.props;
      const buildFilterParams = (filterKey, directoryId=null) => {
        if(filterKey === 'All'){
          return directoryId ? `?directory_id=${directoryId}` : '?';
        }
        const params = [];
        if(directoryId){
          params.push(`directory_id=${directoryId}`);
        }
        switch(filterKey){
          case 'Images':
            params.push('image_only=true');
            break;
          case 'Documents':
            params.push('document_only=true');
            break;
          case 'Favourite':
            params.push('favourite_only=true');
            break;
          default:
            break;
        }
        return `?${params.join('&')}`;
      };
      const filterKey = activeHeaderTab || ListingModules || 'All';
      const paramListing = buildFilterParams(filterKey, ListingDirectoryID || null);
	   const queryParams=`&query=${search}&page=${page * perPage}&orderBy=${orderBy}&size=${perPage}&direction=${direction}`
      this.props.Loader(true)
      let folderRows = [];
      if(ListingModules === 'Directory' && ListingDirectoryID && activeHeaderTab == "Favourite"){     
          try{
          const folderRes = await callGET(`document/search?directory_id=${ListingDirectoryID}&directory_only=true`);
          if(folderRes.status === 200){
            const folderResponse = folderRes.data;
            if(folderResponse.code === 200){
              const folderDocuments = (folderResponse.data && folderResponse.data.length!==0)?folderResponse.data[0].documents:[];
              folderRows = this.transformDocuments(folderDocuments);
            }
          }
        }catch(folderError){
          console.log('Folder fetch failed', folderError);
        }
      }
      try{
        const res = await callGET("document/search"+paramListing+queryParams);
        if(res.status===200){ 
          const response = res.data;
          if(response.code===200){             
            const documents = (response.data!==undefined && response.data.length!==0)?response.data[0].documents:[];
            const documentRows = this.transformDocuments(documents);
            const updateTableData = [...folderRows, ...documentRows];
            const totalRecords = (response.data!==undefined && response.data.length!==0)?response.data[0].count:0;
            this.setState({status:200, tableRecords:{
              tableData:{data:updateTableData,status:200},
              tableHead:this.state.tableRecords.tableHead ,
              pagination:{...pagination,totalRecords:totalRecords}
            }});
          }else{
            const totalRecords = 0;
            this.setState({status:200, tableRecords:{
              tableData:{data:folderRows,status:(folderRows.length>0)?200:400},
              tableHead:this.state.tableRecords.tableHead ,
              pagination:{...pagination,totalRecords:totalRecords}
            }});
          }
        }
      }catch(error){
        console.log(error);
      }finally{
        this.props.Loader(false)
      }
    }

    transformDocuments = (documents=[]) => {
      return documents.map((item,index)=>{
        let isFav = '';
        if(item.favourite === true){ isFav = 'text-warning';} 

        let isFileOrFolder = 'fas fa-folder text-success'
        if(item.type){
          isFileOrFolder = 'fas fa-file text-success';	
        }

        let settings = '';
        let moveAction = '';
        let copyAction = '';
        let favAction = '';
        if(item.type){
          settings = "";
          moveAction = {
            clickHandler:this.props.toggleDirectoryChoosePopup.bind(this,'Move',item.id),
            attributes:{
              className:"dropdown-item"
            },
            access_mode:true,
            name:"Move"	
          }

          copyAction = {
            clickHandler:this.props.toggleDirectoryChoosePopup.bind(this,'Copy',item.id),
            attributes:{
              className:"dropdown-item"
            },
            access_mode:true,
            name:"Copy"	
          } 

          favAction = {
            attributes:{
              className:"p-1"
            },
            iconClass:'fas fa-star '+isFav,
            access_mode:true,
            href:"#",
            name:"",
            clickHandler: this.props.assignFavouriteHandler.bind(this,item.id,!item.favourite)
          }              	
        }else {
          settings = {
            clickHandler:this.props.toggleSubFolderPopup.bind(this,item.id),
            attributes:{
              className:"dropdown-item"
            },
            access_mode:true,
            name:"Create Sub Folder"
          }
          
          favAction = {
            attributes:{
              className:"p-1"
            },
            iconClass:'fas fa-star invisible',
            access_mode:true,
            href:"#",
            name:""
          }
        }
        const settingActionMore = [
          {
            clickHandler:(item.type)?this.props.deleteFileHandler.bind(this,item.id):this.props.deleteDirectoryHandler.bind(this,item.id),
            attributes:{
              className:"dropdown-item"
            },
            access_mode:true,
            name:"Delete"
          },
          {
            clickHandler:(item.type)?this.props.downloadFileHandler.bind(this,item.id, item.name):this.props.downloadDirectoryHandler.bind(this,item.id),
            attributes:{
              className:"dropdown-item"
            },
            access_mode:true,
            name:"Download"
          },
          settings,
          moveAction,
          copyAction
        ];
        return {
          className:'icon_hover cursor-pointer',
          rowId:"",
          gData:{...item,actionMore:settingActionMore},
          data:{
            actions:[
              favAction,
              {
                attributes:{
                  className:"p-1"
                },
                iconClass:isFileOrFolder,
                access_mode:true,
                name:""
              }
            ],
            file_name:{
              value: item.name,
              clickHandler: (item.type)?'':this.props.assignListingModules.bind(this,'Directory',item.id, item, 'list'),
              param:{
                data:{...item},
              },
              attributes:{
                id: item.id                        
              },
              setting:{
                attributes:{},
                actionMore:settingActionMore
              },                    
            },
            owner:item.document_owner,
            type:item.type,
            size:item.size ? formatBytes(item.size) : '',
          }
        }
      });
    }

    render () {
    	// console.log('ListingType',this.props.ListingType);
    	const { breadcrumbPath, navigateBreadcrumb, ListingModules, breadcrumbFromSidebar } = this.props;
    	const showBreadcrumbs = ListingModules === 'Directory' && breadcrumbPath && breadcrumbPath.length > 0;
    	// Show "Document" prefix only if not from sidebar (when from sidebar, start from folder name)
    	const showDocumentPrefix = !breadcrumbFromSidebar;
    	
    	return(
	        <Wrp>
	        	<div className="view view-xl" id="wrapper">
					<div className="outerPort" style={{overflow:"auto", left:"0px", top:"5px"}}>
						{/* Breadcrumb Navigation */}
						{showBreadcrumbs && (
							<div className="breadcrumb-container" style={{padding: '10px 15px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6'}}>
								<ul className="breadcrumbs mb-0" style={{listStyle: 'none', display: 'flex', alignItems: 'center', padding: 0, margin: 0}}>
									{showDocumentPrefix && (
										<>
											<li className="nav-item" style={{cursor: 'pointer'}} onClick={() => navigateBreadcrumb(-1)}>
												<span className="text-info">Document</span>
											</li>
											{breadcrumbPath.length > 0 && (
												<li className="separator" style={{margin: '0 8px', color: '#6c757d'}}>
													<i className="fas fa-chevron-right"></i>
												</li>
											)}
										</>
									)}
									{breadcrumbPath.map((crumb, index) => (
										<React.Fragment key={crumb.id}>
											{index > 0 && (
												<li className="separator" style={{margin: '0 8px', color: '#6c757d'}}>
													<i className="fas fa-chevron-right"></i>
												</li>
											)}
											<li 
												className="nav-item" 
												style={{cursor: (breadcrumbFromSidebar && index === 0 && breadcrumbPath.length === 1) ? 'default' : 'pointer'}} 
												onClick={(breadcrumbFromSidebar && index === 0 && breadcrumbPath.length === 1) ? undefined : () => navigateBreadcrumb(index)}
											>
												<span className={(breadcrumbFromSidebar && index === 0 && breadcrumbPath.length === 1) ? 'text-muted' : 'text-info'}>{crumb.name}</span>
											</li>
										</React.Fragment>
									))}
								</ul>
							</div>
						)}
						<div className={(this.props.ListingType === 'Table') ? "table_Box " : "card-body"} style={{height:"calc(90vh - 104px)"}} >
							{
								(this.props.ListingType === 'Table') ?
								<DocumentListing
									tableRecords={this.state.tableRecords}
									callListingData={this.callListingData}
								/>
								:
								<GridListing assignListingModules={this.props.assignListingModules} tableRecords={this.state.tableRecords} />
							}
						</div>     
					</div>    			
	          </div>
	        </Wrp>
	    )	
    }
}

export default MainContent;

